import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { sliderArrowRight } from "../../../assets/img/sliderArrowRight";
import { changeLang } from "../../../store/app/appSlice";
import { FooterLangSwitch, LangSwitchFooter, LangSwitchWrapperFooter } from "../../Footer/Footer.styled";
import { CreateDropdown } from "../CreateDropdown/CreateDropdown";
import { CreateButtonMobile, MobileMenuBody, MobileMenuWrapper } from "./MobileMenu.styled";

export const MobileMenu = ({ openMenu, closeMenu }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showLangSwitch, setShowLangSwitch] = useState(false);
  const lang = useSelector((state) => state.app.lang);
  const dispatch = useDispatch();
  const location = useLocation();

  let whiteText = location.pathname.includes("/collections/") || location.pathname.includes("/creators/");

  return (
    <MobileMenuWrapper openMenu={openMenu}>
      <MobileMenuBody>
        <Link to='/marketplace' onClick={() => closeMenu()}>
          Mаrketplаce
        </Link>
        <Link to='/' onClick={() => closeMenu()}>
          Telegrаm Chаnnel
        </Link>
        <Link to='/' onClick={() => closeMenu()}>
          FАQ
        </Link>
        <LangSwitchWrapperFooter showLangSwitch={showLangSwitch}>
          {sliderArrowRight()}
          <LangSwitchFooter whiteText={whiteText} showLangSwitch={showLangSwitch} onClick={() => setShowLangSwitch(!showLangSwitch)}>
            <span className={lang !== "EN" && "hidden"} onClick={() => (dispatch(changeLang("EN")), setShowLangSwitch(false))}>
              English
            </span>
            <span className={lang !== "Укр" && "hidden"} onClick={() => (dispatch(changeLang("Укр")), setShowLangSwitch(false))}>
              Українська
            </span>
            <span className={lang !== "Рус" && "hidden"} onClick={() => (dispatch(changeLang("Рус")), setShowLangSwitch(false))}>
              Русский
            </span>
          </LangSwitchFooter>
        </LangSwitchWrapperFooter>
        <CreateButtonMobile onClick={() => setShowDropdown(!showDropdown)}>Create</CreateButtonMobile>
        {showDropdown && (
          <CreateDropdown
            closeMenu={closeMenu}
            styles={{
              position: "relative",
              top: "initial",
              left: "initial",
              margin: "20px 0 10px",
            }}
          />
        )}
      </MobileMenuBody>
    </MobileMenuWrapper>
  );
};
